import CONSTANTS from '../../../constants';

export function products(state = { data: null, loading: true }, action) {
  if (action.type === CONSTANTS.ACTIONS.PRODUCT.PRODUCT_ALL) {
    const { data } = action;
    return { data: data ? data.response : data, loading: action.loading};
  }
  return state;
}